import React from "react";
import moment from "moment";

import { IColum } from "../../../../utils/copyToClipboardInXlsFormat";
import { CopyToClipboard } from "../../../../components/ui";
import { IntlFormatUSD } from "../../../../utils";
import { CENTS_IN_DOLLAR, DATE_FORMAT } from "../../../../constants";
import { IIWithdrawalsResponseRow } from "../../../../api/compliance/index.types";

export const WITHDRAWALS_COLUMNS: Array<IColum> = [
  {
    by: "account_name",
    title: "Funded account name",
    path: "account_name",
  },
  {
    by: "name",
    title: "Name",
    path: "account.name",
    // @ts-ignore
    getCellValue: (value: string, restValues: IIWithdrawalsResponseRow) => (
      <CopyToClipboard value={value || restValues?.submissions_outer_account?.name || ""} />
    ),
    // @ts-ignore
    copyToClipBoardCallBack: (value: string, restValues: IIWithdrawalsResponseRow): string => {
      return value || restValues?.submissions_outer_account?.name || "";
    },
  },
  {
    by: "email",
    title: "Email",
    path: "account.email",
    // @ts-ignore
    getCellValue: (value: string, restValues: IIWithdrawalsResponseRow) => (
      <CopyToClipboard value={value || restValues?.submissions_outer_account?.email || ""} />
    ),
    // @ts-ignore
    copyToClipBoardCallBack: (value: string, restValues: IIWithdrawalsResponseRow): string => {
      return value || restValues?.submissions_outer_account?.name || "";
    },
  },
  {
    by: "amount_requested",
    title: "Amount requested",
    path: "amount_requested",
    copyToClipBoardCallBack: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
    getCellValue: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
  },
  {
    by: "w80",
    title: "80%",
    path: "w80",
    copyToClipBoardCallBack: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
    getCellValue: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
  },
  {
    by: "w20",
    title: "20%",
    path: "w20",
    copyToClipBoardCallBack: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
    getCellValue: (value) => IntlFormatUSD(+value / CENTS_IN_DOLLAR),
  },
  {
    by: "request_date",
    title: "Request date",
    path: "initialization_date",
    getCellValue: (value) => moment(value as unknown as string).format(DATE_FORMAT),
    copyToClipBoardCallBack: (value) => moment(value as unknown as string).format(DATE_FORMAT),
  },
  {
    by: "payout_date",
    title: "Payout date",
    path: "changed_status_time",
    getCellValue: (value) => (value ? moment(value as unknown as string).format(DATE_FORMAT) : ""),
    copyToClipBoardCallBack: (value) =>
      value ? moment(value as unknown as string).format(DATE_FORMAT) : "",
  },
  {
    by: "status",
    title: "Status",
    path: "status",
  },
];
